import {
    PsHttpService,
    type PatSnapSuccessResponseData,
} from '@patsnap/tahiti-core/common/ps-http';
import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { ContentBlock } from '../../types';
import { currentClientUUID } from '@patsnap/uniform-setting';

// ==================== Request Types ====================

/**
 * 初始化 Hiro 会话请求参数
 */
export interface InitHiroSessionRequest {
    /** 内容块数组（包含文本和图片） */
    content: ContentBlock[];
}

/**
 * 初始化 Hiro 会话响应
 */
export interface InitHiroSessionResponse {
    /** 问题ID */
    id: string;
}

// ==================== API Interface ====================

export interface HiroApi {
    /**
     * 初始化 Hiro 会话
     */
    initSession(data: InitHiroSessionRequest): Promise<InitHiroSessionResponse>;
}

export const HiroApi = Symbol('HiroApi');

// ==================== API Implementation ====================

@injectable()
export class HiroApiImpl extends PsHttpService implements HiroApi {
    get options() {
        return {
            baseURL: `${import.meta.env.VITE_CORE_SEARCH_SERVICE_URI}/core-search-api/search`,
            headers: {
                'X-Device-ID': currentClientUUID(),
                'X-API-Version': '2.0',
            },
        };
    }

    initSession(data: InitHiroSessionRequest) {
        return this.post<PatSnapSuccessResponseData<InitHiroSessionResponse>>({
            url: '/hiro/init',
            data,
        }).then((res) => {
            return res.data;
        });
    }
}
